(function(){
/* Every ID, plan and price comes from window.ADAPTORY (snippets/adaptory-config.liquid). */
var A = window.ADAPTORY;
var CREATINE_ID = A.cre.id;
var TUBS = {}, CADENCE = {}, CADENCE_WORD = {}, CREATINE_PLANS = {};
TUBS[A.cre.id]  = A.cre.tubs;  CADENCE[A.cre.id]  = A.cre.weeks;  CADENCE_WORD[A.cre.id]  = 'monthly';      CREATINE_PLANS[A.cre.id]  = A.cre.plan;
TUBS[A.cre2.id] = A.cre2.tubs; CADENCE[A.cre2.id] = A.cre2.weeks; CADENCE_WORD[A.cre2.id] = '2-month plan'; CREATINE_PLANS[A.cre2.id] = A.cre2.plan;
var MAG_CADENCE = A.mag.weeks;
function cadenceOf(vid){ return CADENCE[vid.toString()] || MAG_CADENCE; }
function cadenceWordOf(vid){ return CADENCE_WORD[vid.toString()] || 'monthly'; }
var TUB_UP = {}, TUB_DOWN = {};
TUB_UP[A.cre.id] = A.cre2.id; TUB_DOWN[A.cre2.id] = A.cre.id;
var MAG_ID = A.mag.id, MAG_PLAN = A.mag.plan;
/* drawer adds the gift line, Bxgy zeroes it. keep true */
var GIFT_AUTOADD = true;
var GIFT_PROP = '_adp_gift';
var PRICE = {};
PRICE[A.cre.id]  = { sub: A.cre.sub,  once: A.cre.once,  compare: A.cre.compare  };
PRICE[A.cre2.id] = { sub: A.cre2.sub, once: A.cre2.once, compare: A.cre2.compare };
PRICE[A.mag.id]  = { sub: A.mag.sub,  once: A.mag.once,  compare: A.mag.compare  };
/* free shipping always, FREE_SHIP_MIN gates nothing */
var FREE_SHIP_MIN = 0;
var MAG_FREE_AT  = 2;
function tubCount(cart, subOnly){
var n = 0;
(cart.items || []).forEach(function(i){
if (subOnly && !i.selling_plan_allocation) return;
n += (TUBS[i.variant_id.toString()] || 0) * (i.quantity || 1);
});
return n;
}
function priceOf(vid, sub){ var p = PRICE[vid.toString()]; return p ? (sub ? p.sub : p.once) : 0; }
var acdBusy = false;
var NO_ONETIME = {};
var MAG_IMG = 'https://cdn.shopify.com/s/files/1/0240/4302/8544/files/hf_20260630_011156_e2e5ba01-e293-4b3b-8dac-9fe0c5150e57_1.png?v=1784517981';
var PROT_ID = A.prot.id;
var PROT_PRICE = A.prot.price;
var PROT_ON = true; try { PROT_ON = sessionStorage.getItem('acdPO') !== '0'; } catch(e) {}
var ACD_BASE = 0;
/* Retired add-on variants. If one is still in an old cart, the drawer removes it. */
var BONUS_GIFTS = {
'45791268077754': { name: 'Insured Shipping' },
'45791268307130': { name: 'Surprise Gifts' }
};
function isCre(vid){ return CREATINE_PLANS.hasOwnProperty(vid.toString()); }
var acdPend = 0;
function busy(on){
var d = document.getElementById('acdDrawer'); if (!d) return;
acdPend = Math.max(0, acdPend + (on ? 1 : -1));
d.classList.toggle('busy', acdPend > 0);
}
function tracked(p){ busy(true); return p.then(function(v){ busy(false); return v; }, function(e){ busy(false); throw e; }); }
var qTimer = {}, qTarget = {};
window.stepTo = function(key, target, numEl){
if (target < 0) target = 0;
qTarget[key] = target;
if (numEl) {
var unit = numEl.querySelector('em');
numEl.firstChild.nodeValue = target;
if (unit) unit.textContent = target === 1 ? 'tub' : 'tubs';
}
clearTimeout(qTimer[key]);
qTimer[key] = setTimeout(function(){
var t = qTarget[key]; delete qTarget[key];
acdQty(key, t);
}, 300);
};
function acdFlash(msg) {
var el = document.getElementById('acdFlash');
if (!el) return;
el.textContent = msg;
el.classList.add('show');
clearTimeout(window.__acdFlashT);
window.__acdFlashT = setTimeout(function(){ el.classList.remove('show'); }, 5200);
}
function syncBonusGifts(cart) {
var updates = {}, need = false;
cart.items.forEach(function(item){
var vid = item.variant_id.toString();
if (BONUS_GIFTS[vid]) { updates[item.key] = 0; need = true; }
});
if (!need) return Promise.resolve(cart);
return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function(r){ return r.json(); });
}
var magSyncing = false;
function isGiftLine(i){ return !!(i.properties && i.properties[GIFT_PROP]); }
function syncFreeMag(cart){
if (magSyncing) return;
var atGift = tubCount(cart, true) >= MAG_FREE_AT;
var updates = {}, need = false, keptGift = false, droppedPaid = false, pulled = false;
(cart.items || []).forEach(function(i){
if (i.variant_id.toString() !== MAG_ID.toString()) return;
if (!atGift){
  if (isGiftLine(i)) { updates[i.key] = 0; need = true; pulled = true; }
  return;
}
if (!GIFT_AUTOADD) return;
var plain = !i.selling_plan_allocation && i.quantity === 1;
if (plain && !keptGift) { keptGift = true; return; }
updates[i.key] = 0; need = true;
if (!plain) droppedPaid = true;
});
var mustAdd = atGift && !keptGift && GIFT_AUTOADD;
if (!need && !mustAdd) return;
magSyncing = true;
acdBusy = true;
busy(true);
Promise.resolve()
.then(function(){
if (!need) return;
return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
})
.then(function(){
if (!mustAdd) return;
return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: MAG_ID, quantity: 1, properties: (function(o){o[GIFT_PROP]='1';return o;})({}) }] }) });
})
.then(function(){ return fetch('/cart.js'); })
.then(function(r){ return r.json(); })
.then(function(c){
magSyncing = false; acdBusy = false; busy(false);
if (pulled) acdFlash('Free Magnesium+ is on the subscription only');
else if (droppedPaid) acdFlash('Magnesium+ is free on 2 tubs');
acdRender(c); acdBubble(c);
})
.catch(function(){ magSyncing = false; acdBusy = false; busy(false); });
}
function acdBubble(cart){
var b = document.querySelector('.cart-count-bubble span[aria-hidden="true"]'); if (b) b.textContent = cart.item_count;
var be = document.querySelector('.cart-count-bubble'); if (be) be.style.display = cart.item_count > 0 ? '' : 'none';
}
function cleanName(title){
var t = (title || '').replace(/\s*\(bundle\)/ig, '').replace(/\s*bundle/ig, '').trim();
return t.replace(/Creatine\s*\+/i, 'Creatine+').replace(/Magnesium\s*\+/i, 'Magnesium+');
}
function nameHtml(title){
return cleanName(title).replace(/Creatine\+/g, 'Creatine<span class="ice">+</span>')
.replace(/Magnesium\+/g, 'Magnesium<span class="ice v">+</span>');
}
function compareFor(item){
var p = PRICE[item.variant_id.toString()];
var price = item.final_price / 100;
if (p && p.compare > price) return p.compare;
if (item.compare_at_price && (item.compare_at_price/100) > price) return item.compare_at_price/100;
return price;
}
function couponFor(item){
var a = item.line_level_discount_allocations;
if (a && a.length && a[0].discount_application && a[0].discount_application.title) return a[0].discount_application.title;
if (item.discounts && item.discounts.length && item.discounts[0].title) return item.discounts[0].title;
return '';
}
var TAG_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
function lineHtml(item, isMag){
var hasPlan = !!item.selling_plan_allocation;
var q = item.quantity;
var price = item.final_price / 100;
var showCompare = compareFor(item);
var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_240x$1$2') : '';
var line1 = isMag ? '275mg elemental' : 'Salty Lemon';
var tubCount = isMag ? 1 : ((TUBS[item.variant_id.toString()] || 1) * q);
var servings = 30 * tubCount;
var cad = isMag ? MAG_CADENCE : cadenceOf(item.variant_id);
var line2 = hasPlan ? ('Shipped every ' + cad) : (servings + ' servings, ships once');
var priceHtml = '<span class="acd-item-price">$' + (price * q).toFixed(2) + '</span>';
if (showCompare > price) priceHtml += '<span class="acd-item-compare">$' + (showCompare * q).toFixed(2) + '</span>';
var pill = '';
if (hasPlan) {
var cadenceWord = isMag ? 'monthly' : cadenceWordOf(item.variant_id);
pill = '<div class="acd-save-pill">' + TAG_SVG + 'Saving w/ ' + cadenceWord + '</div>';
}
var code = couponFor(item);
var coupon = code ? '<span class="acd-coupon">' + TAG_SVG + code + '</span>' : '';
var tubs = TUBS[item.variant_id.toString()] || 0;
var qty;
if (tubs) {
var shown = tubs * q;
var up = TUB_UP[item.variant_id.toString()];
var canUp = (q > 1) || !!up;
var dn = "acdTubs('" + item.key + "'," + item.variant_id + "," + q + ",-1," + (hasPlan ? 1 : 0) + ",event)";
var upA = "acdTubs('" + item.key + "'," + item.variant_id + "," + q + ",1," + (hasPlan ? 1 : 0) + ",event)";
qty = '<div class="acd-qty"><button onclick="' + dn + '" aria-label="Fewer tubs">&minus;</button>'
+ '<div class="acd-qty-num">' + shown + '<em>' + (shown === 1 ? 'tub' : 'tubs') + '</em></div>'
+ '<button onclick="' + (canUp ? upA : '') + '"' + (canUp ? '' : ' disabled') + ' aria-label="More tubs">+</button></div>';
} else {
qty = '<div class="acd-qty"><button onclick="stepTo(\'' + item.key + '\',' + (q - 1) + ',this.parentElement.querySelector(\'.acd-qty-num\'))" aria-label="Decrease">&minus;</button><div class="acd-qty-num">' + q + '</div><button onclick="stepTo(\'' + item.key + '\',' + (q + 1) + ',this.parentElement.querySelector(\'.acd-qty-num\'))" aria-label="Increase">+</button></div>';
}
var delSvg = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="3"/><line x1="9" y1="9" x2="15" y2="15"/><line x1="15" y1="9" x2="9" y2="15"/></svg>';
return '<div class="acd-item" data-k="' + item.key + '">'
+ '<button class="acd-del" onclick="acdQty(\'' + item.key + '\',0)" aria-label="Remove">' + delSvg + '</button>'
+ '<div class="acd-item-img">' + (imgSrc ? '<img src="' + imgSrc + '" alt="">' : '') + '</div>'
+ '<div class="acd-item-info">'
+ '<div class="acd-item-name">' + nameHtml(item.product_title) + '</div>'
+ '<div class="acd-item-sub">' + line1 + '<br>' + line2 + '</div>'
+ '<div class="acd-item-pricerow">' + priceHtml + '</div>'
+ pill
+ '<div class="acd-item-bottom">' + qty + coupon + '</div>'
+ stepCta(item, hasPlan)
+ planToggle(item, hasPlan, isMag)
+ '</div>'
+ giftRow(item)
+ '</div>';
}
function giftRow(item){
if ((TUBS[item.variant_id.toString()] || 0) < MAG_FREE_AT) return '';
if (!item.selling_plan_allocation) return '';
var img = MAG_IMG ? '<img src="' + MAG_IMG + '" alt="Magnesium+">' : 'Mg+';
var bens = ['275mg elemental, from 2,500mg glycinate','Deeper sleep','Less cramping'];
var tk = '<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>';
return '<div class="acd-gift">'
+ '<div class="gtop"><span class="gtag">Your free gift</span>'
+ '<span class="gv"><s>$' + A.mag.compare.toFixed(2) + '</s><b>FREE</b></span></div>'
+ '<div class="ghd"><span class="gi">' + img + '</span>'
+ '<span class="gt"><b>Magnesium<span class="ice v">+</span></b>'
+ '<span class="sub">You recover while you sleep, not while you train.</span></span></div>'
+ '<div class="gbin">'
+ bens.map(function(b){ return '<span>' + tk + b + '</span>'; }).join('')
+ '</div></div>';
}
function planToggle(item, hasPlan, isMag){
var vid = item.variant_id.toString();
if (NO_ONETIME[vid]) return '';
var plan = isMag ? MAG_PLAN : CREATINE_PLANS[vid];
if (!plan) return '';
var sub = priceOf(vid, true), once = priceOf(vid, false);
if (!sub || !once) return '';
var q = item.quantity || 1;
var cad = isMag ? MAG_CADENCE : cadenceOf(vid);
if (hasPlan) {
var dif=(once-sub)*q;
var gf=(TUBS[vid]||0)>=MAG_FREE_AT?', and no free gift':'';
return '<div class="acd-sw"><button class="swh" type="button" aria-expanded="false" onclick="acdSw(event)">'
+ '<span>Delivered every ' + cad + '<i>Skip or cancel anytime</i></span>'
+ '<svg class="swc" viewBox="0 0 24 24" fill="none" stroke-width="2.8" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>'
+ '</button><div class="swb"><div class="swin">'
+ '<div class="swr" onclick="acdSetPlan(\'' + item.key + '\',' + item.variant_id + ',0,' + q + ',event)">'
+ '<span class="swl">Switch to one-time purchase</span><b class="swu">$' + (once*q).toFixed(2) + '</b></div>'
+ '<div class="swn"><b>$' + dif.toFixed(2) + ' more</b>' + gf + '.</div>'
+ '</div></div></div>';
}
var saveAmt = (once - sub) * q;
var arrow = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13M12 5l7 7-7 7"/></svg>';
return '<button class="acd-up" onclick="acdSetPlan(\'' + item.key + '\',' + item.variant_id + ',' + plan + ',' + q + ',event)">'
+ '<span class="acd-up-l"><span class="acd-up-t">Autoship &amp; save $' + saveAmt.toFixed(2) + '</span>'
+ '<span class="acd-up-s">Every ' + cad + ' &middot; skip or cancel anytime</span></span>'
+ '<span class="acd-up-r"><span class="acd-up-p">$' + (sub * q).toFixed(2) + '</span>' + arrow + '</span></button>';
}
function rewardSlider(tubs, allTubs){
var tick = '<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>';
var gift = '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">'
+ '<rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18"/>'
+ '<path d="M12 8S10.5 3 8 3a2.5 2.5 0 000 5M12 8s1.5-5 4-5a2.5 2.5 0 010 5"/></svg>';
var atMag = tubs >= MAG_FREE_AT;
var two = PRICE[A.cre2.id];
var off = Math.round((1 - two.sub / two.compare) * 100);
/* they already own enough tubs, they are just not subscribed. Do not tell
   them to add a tub they have, tell them the thing that actually unlocks it. */
var hasTubs = allTubs >= MAG_FREE_AT;
var pct = atMag ? 100 : ((tubs >= 1 || hasTubs) ? 50 : 6);
var msg = atMag
? '<b>' + off + '% OFF</b> &middot; <b>FREE SHIPPING</b> &middot; <b>FREE MAGNESIUM+</b>'
: (hasTubs
   ? 'Switch to Autoship for <b>' + off + '% off</b> and a <b>free Magnesium+</b>'
   : 'Add 1 more tub for <b>' + off + '% off</b> and a <b>free Magnesium+</b>');
return '<div class="acd-rw' + (atMag ? ' done' : '') + '">'
+ '<div class="acd-rw-msg">' + msg + '</div>'
+ '<div class="acd-rw-bar">'
+ '<span class="acd-rw-fill' + (atMag ? ' full' : '') + '" style="width:' + pct + '%"></span>'
+ '<span class="acd-rw-goal">' + (atMag ? tick : gift) + '</span>'
+ '</div></div>';
}
function stepCta(cre, creSub){
if (!cre || (cre.quantity || 1) !== 1) return '';
var vid = cre.variant_id.toString(), nextId = TUB_UP[vid];
if (!nextId) return '';
var nextKey = nextId.toString();
var nextTubs = TUBS[nextKey] || 0;
var nextP = priceOf(nextId, creSub);
if (!nextP || !nextTubs) return '';
var isMag = nextTubs >= MAG_FREE_AT;
var arrow = '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13M12 5l7 7-7 7"/></svg>';
return '<button class="acd-step' + (isMag ? ' mag' : '') + '" onclick="acdTubs(\'' + cre.key + '\',' + cre.variant_id + ',1,1,' + (creSub ? 1 : 0) + ',event)">'
+ '<span class="l">Make it ' + nextTubs + ' tubs<span>$' + (nextP / nextTubs).toFixed(2) + '/tub</span></span>'
+ '<span class="r">' + (isMag ? 'Free gift' : 'Save more') + arrow + '</span></button>';
}
function upsellLadder(cre, creSub, mag, magSub, tubs){
if (tubs >= MAG_FREE_AT || !cre || mag) return '';
return '<div class="acd-ups">' + rungMag(creSub) + '</div>';
}
function rungMag(creSub){
var img = MAG_IMG ? '<img src="' + MAG_IMG + '" alt="Magnesium+">' : 'Mg+';
var mp = PRICE[MAG_ID], now = creSub ? mp.sub : mp.once;
var plan = creSub ? MAG_PLAN : 0;
return '<div class="acd-magslim">'
+ '<div class="top"><span class="i">' + img + '</span>'
+ '<span class="t"><b>Magnesium+</b><span class="sub">Most people pair these with Creatine+</span></span>'
+ '<span class="bdg">In-cart discount</span></div>'
+ '<div class="ben"><span>Deeper sleep</span><span>Overnight recovery</span><span>Less tension</span></div>'
+ '<div class="foot"><span class="pr"><s>$' + mp.compare + '</s><b>$' + now + '</b></span>'
+ '<button class="b" onclick="acdAdd(' + MAG_ID + ',' + plan + ',event)">Add to order</button></div>'
+ '</div>';
}
function acdRender(cart) {
var body = document.getElementById('acdBody');
var footer = document.getElementById('acdFooter');
document.getElementById('acdCount').textContent = cart.item_count;
var realItems = (cart.items || []).filter(function(i){
var v = i.variant_id.toString();
return !BONUS_GIFTS[v] && v !== PROT_ID.toString();
});
if (!realItems.length) {
var orphan = null;
(cart.items || []).forEach(function(i){ if (i.variant_id.toString() === PROT_ID.toString()) orphan = i.key; });
if (orphan) {
var uo = {}; uo[orphan] = 0;
fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: uo }) })
.then(function(r){ return r.json(); }).then(function(c){ acdBubble(c); });
}
body.className = 'acd-empty';
body.innerHTML = '<div class="acd-empty-glyph">+</div><div class="acd-empty-title">Your cart is empty</div>'
+ '<div class="acd-empty-sub">Add Creatine+ and get back to it.</div>'
+ '<div class="acd-emptybuy">'
+ '<button class="acd-eb-main" onclick="acdAdd(' + CREATINE_ID + ',' + CREATINE_PLANS[CREATINE_ID.toString()] + ',event)">'
+ '<span class="acd-eb-t">Add Creatine+ &middot; $' + priceOf(CREATINE_ID, true).toFixed(2) + '</span>'
+ '<span class="acd-eb-s">Every ' + cadenceOf(CREATINE_ID) + ' &middot; skip or cancel anytime</span></button>'
+ '<button class="acd-eb-alt" onclick="acdAdd(' + CREATINE_ID + ',0,event)">One-time &middot; $' + priceOf(CREATINE_ID, false).toFixed(2) + '</button>'
+ '<a class="acd-eb-link" href="/products/creatine-plus" onclick="acdClose()">See the full product &rarr;</a>'
+ '</div>';
footer.innerHTML = ''; return;
}
body.className = 'acd-items';
var subtotal = cart.total_price / 100;
var compareTotal = 0;
var truckSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
var tubs = tubCount(cart, true);
var shipFree = true;   /* free shipping on every order */
var html = '';
var cre = null, mag = null, prot = null, others = [];
cart.items.forEach(function(item){
var vid = item.variant_id.toString();
if (BONUS_GIFTS[vid]) return;
if (tubs >= MAG_FREE_AT && vid === MAG_ID.toString()) return;
if (vid === PROT_ID.toString()) { prot = item; return; }
var t = item.product_title || '';
if (/creatine/i.test(t)) { if (!cre) cre = item; else others.push(item); }
else if (/magnesium/i.test(t)) { if (!mag) mag = item; else others.push(item); }
else others.push(item);
});
var creSub = cre && !!cre.selling_plan_allocation;
var magSub = mag && !!mag.selling_plan_allocation;
html = rewardSlider(tubs, tubCount(cart)) + html;
if (creSub) { html += lineHtml(cre, false); compareTotal += compareFor(cre) * cre.quantity; }
if (magSub) { html += lineHtml(mag, true); compareTotal += compareFor(mag) * mag.quantity; }
if ((creSub || magSub) && ((cre && !creSub) || (mag && !magSub))) html += '<div class="acd-sec">One-time purchase</div>';
if (cre && !creSub) {
html += lineHtml(cre, false); compareTotal += compareFor(cre) * cre.quantity;
}
if (mag && !magSub) {
html += lineHtml(mag, true); compareTotal += compareFor(mag) * mag.quantity;
}
others.forEach(function(it){ html += lineHtml(it, false); compareTotal += compareFor(it) * it.quantity; });
html += upsellLadder(cre, creSub, mag, magSub, tubs);
var savings = compareTotal - subtotal;
var savePct = compareTotal > 0 ? Math.round((savings / compareTotal) * 100) : 0;
var discTags = '';
(cart.cart_level_discount_applications || []).forEach(function(d){ if (d && d.title) discTags += '<span class="acd-sum-tag">' + d.title + '</span>'; });
var keepScroll = body.scrollTop;
body.innerHTML = html;
body.scrollTop = keepScroll;
var fHtml = '<div class="acd-footer">';
fHtml += '<div class="acd-subtotal"><div class="acd-sub-label">Subtotal</div><div class="acd-sub-right">';
if (savePct > 0) fHtml += '<span class="acd-sub-pct">' + savePct + '% OFF</span><span class="acd-sub-compare">$' + compareTotal.toFixed(2) + '</span>';
fHtml += '<span class="acd-sub-total">$' + subtotal.toFixed(2) + '</span></div></div>';
fHtml += '<div class="acd-fmeta"><span>' + (shipFree ? '<b class="fx">Free shipping</b>' : 'Shipping') + '</span>'
+ '<span>Taxes at checkout</span></div>';
if (discTags) fHtml += '<div class="acd-ftags">' + discTags + '</div>';
var pOn = PROT_ON;
ACD_BASE = prot ? (subtotal - PROT_PRICE) : subtotal;
var coTotal = ACD_BASE + (pOn ? PROT_PRICE : 0);
fHtml += '<div class="acd-prot"><svg class="sh" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>'
+ '<span class="t"><b>Shipping Protection</b> &middot; $' + PROT_PRICE.toFixed(2) + '</span>'
+ '<button class="acd-protq" onclick="acdProtInfo(event)" aria-label="What is Shipping Protection?">?</button>'
+ '<button class="acd-tg' + (pOn ? ' on' : '') + '" role="switch" aria-checked="' + (pOn ? 'true' : 'false') + '" aria-label="Shipping Protection" onclick="acdProtT(this)"></button></div>';
fHtml += '<div class="acd-prottip" id="acdProtTip"><div>Covers your order from the moment it ships. If it arrives <b>damaged</b>, or turns up <b>lost or stolen</b>, we send a replacement free. No claim forms and no carrier runaround, just email us. Covered for 30 days from the ship date.</div></div>';
var cartSvg = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.4 12.1a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.3L21 7H6"/></svg>';
fHtml += '<div class="acd-checkout-wrap"><button class="acd-checkout" onclick="acdCheckout(PROT_ON)">' + cartSvg + '<span class="acd-co-t" id="acdCoT">Checkout &middot; $' + coTotal.toFixed(2) + '</span></button></div>';
fHtml += '</div>';
footer.innerHTML = fHtml;
syncFreeMag(cart);
}
window.acdOpen = function() {
fetch('/cart.js').then(function(r){ return r.json(); })
.then(function(cart){ return syncBonusGifts(cart); })
.then(function(cart){
acdRender(cart);
var bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
if (bubble) bubble.textContent = cart.item_count;
var bubbleEl = document.querySelector('.cart-count-bubble');
if (bubbleEl) bubbleEl.style.display = cart.item_count > 0 ? '' : 'none';
document.getElementById('acdOverlay').classList.add('open');
document.getElementById('acdDrawer').classList.add('open');
document.body.style.overflow = 'hidden';
})
.catch(function(){});
};
window.acdClose = function() { document.getElementById('acdOverlay').classList.remove('open'); document.getElementById('acdDrawer').classList.remove('open'); document.body.style.overflow = ''; };
window.acdSetPlan = function(key, variantId, planId, qty, ev) {
if (qty < 1) qty = 1;
var row = null;
if (ev && ev.target) row = ev.target.closest('.acd-item');
if (!row) { var el = document.querySelector('[data-k="' + key + '"]'); if (el) row = el; }
if (row) {
row.classList.add('pend');
}
var sameVariant = true;
var line = null;
return tracked(fetch('/cart/change.js', {
method: 'POST', headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: key, quantity: qty, selling_plan: planId || null })
}).then(function(r){ return r.json(); }))
.then(function(cart){
var ok = false;
(cart.items || []).forEach(function(i){
if (i.variant_id.toString() !== variantId.toString()) return;
var has = !!i.selling_plan_allocation;
if (has === !!planId) ok = true;
});
if (ok) { acdRender(cart); acdBubble(cart); return cart; }
return swapFallback(key, variantId, planId, qty);
})
.catch(function(){ return swapFallback(key, variantId, planId, qty); });
};
function swapFallback(key, variantId, planId, qty) {
var updates = {}; updates[key] = 0;
return tracked(fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
.then(function(r){ return r.json(); })
.then(function(){
var item = { id: variantId, quantity: qty };
if (planId) item.selling_plan = planId;
return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
})
.then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); }))
.then(function(cart){ acdRender(cart); acdBubble(cart); return cart; });
}
window.acdTubs = function(key, variantId, qty, dir, isSub, ev) {
var vid = variantId.toString();
var target = 0;
if (dir > 0) { if (qty === 1 && TUB_UP[vid]) target = TUB_UP[vid]; }
else { if (qty === 1 && TUB_DOWN[vid]) target = TUB_DOWN[vid]; }
if (target) {
var row = ev && ev.target ? ev.target.closest('.acd-item') : null;
if (row) row.classList.add('pend');
var plan = isSub ? CREATINE_PLANS[target.toString()] : 0;
return acdSetPlan(key, target, plan, 1, ev);
}
var next = qty + dir;
var numEl = ev && ev.target ? ev.target.parentElement.querySelector('.acd-qty-num') : null;
var tubs = TUBS[vid] || 1;
if (numEl && next >= 1) {
var unit = numEl.querySelector('em');
numEl.firstChild.nodeValue = tubs * next;
if (unit) unit.textContent = (tubs * next) === 1 ? 'tub' : 'tubs';
}
clearTimeout(qTimer[key]);
qTarget[key] = next;
qTimer[key] = setTimeout(function(){ var t = qTarget[key]; delete qTarget[key]; acdQty(key, t); }, 300);
};
window.acdAdd = function(variant, plan, ev) {
var card = ev && ev.target ? ev.target.closest('.acd-magslim') : document.querySelector('.acd-magslim');
if (card) card.classList.add('pend');
var item = plan ? { id: variant, quantity: 1, selling_plan: plan } : { id: variant, quantity: 1 };
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
.then(function(r){ return r.json(); })
.then(function(){ acdOpen(); });
};
window.acdSw = function(ev) {
if (ev) ev.stopPropagation();
var h = ev.currentTarget, w = h.parentElement, b = w.querySelector('.swb');
var open = w.classList.toggle('open');
b.style.maxHeight = open ? b.scrollHeight + 'px' : null;
h.setAttribute('aria-expanded', open ? 'true' : 'false');
};
window.acdProtInfo = function(ev) {
if (ev) { ev.preventDefault(); ev.stopPropagation(); }
var t = document.getElementById('acdProtTip');
if (t) t.classList.toggle('show');
};
window.acdProtT = function(el) {
PROT_ON = !PROT_ON;
try { sessionStorage.setItem('acdPO', PROT_ON ? '1' : '0'); } catch(e) {}
el.classList.toggle('on', PROT_ON);
el.setAttribute('aria-checked', PROT_ON ? 'true' : 'false');
var t = document.getElementById('acdCoT');
if (t) t.innerHTML = 'Checkout &middot; $' + (ACD_BASE + (PROT_ON ? PROT_PRICE : 0)).toFixed(2);
};
window.acdCheckout = function(withProt) {
busy(true);
var go = function(){ window.location.href = '/checkout'; };
fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
var key = null;
(cart.items || []).forEach(function(i){ if (i.variant_id.toString() === PROT_ID.toString()) key = i.key; });
if (withProt && !key) {
return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: PROT_ID, quantity: 1 }] }) })
.then(function(r){
if (!r.ok) { return r.json().then(function(e){ console.warn('Shipment Protection could not be added:', e); }); }
return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(x){ return x.json(); }).then(function(c2){
var ok = (c2.items || []).some(function(i){ return i.variant_id.toString() === PROT_ID.toString(); });
if (!ok) console.warn('Shipment Protection add did not persist.');
});
});
}
if (!withProt && key) {
var u = {}; u[key] = 0;
return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: u }) });
}
}).then(go).catch(go);
};
window.acdQty = function(key, qty) {
tracked(fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }))
.then(function(r){ return r.json(); })
.then(function(cart){ return syncBonusGifts(cart); })
.then(function(cart){
acdRender(cart);
var bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
if (bubble) bubble.textContent = cart.item_count;
var bubbleEl = document.querySelector('.cart-count-bubble');
if (bubbleEl) bubbleEl.style.display = cart.item_count > 0 ? '' : 'none';
});
};
var originalFetch = window.fetch;
window.fetch = function() {
var url = arguments[0];
var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
if (urlStr.indexOf('/cart/add') > -1) {
if (acdBusy) { return originalFetch.apply(this, arguments); }
return originalFetch.apply(this, arguments).then(function(response) { setTimeout(function(){ if (!acdBusy) acdOpen(); }, 300); return response; });
}
return originalFetch.apply(this, arguments);
};
document.addEventListener('click', function(e) {
var link = e.target.closest('a[href="/cart"]') || e.target.closest('#cart-icon-bubble') || e.target.closest('.cart-icon-bubble');
if (link && !e.target.closest('.acd')) { e.preventDefault(); e.stopPropagation(); acdOpen(); }
}, true);
document.addEventListener('keydown', function(e) { if (e.key === 'Escape') acdClose(); });
})();
